import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreHours } from 'src/app/models/dashboard/store-hours';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-store-hours',
  templateUrl: './store-hours.component.html',
  styleUrls: ['./store-hours.component.scss']
})
export class StoreHoursComponent {

	@Input() addressId: number;
	@Input() storeHours: StoreHours;
	@Output() onCancel: EventEmitter<boolean> = new EventEmitter();

	public errors: any = {};

	constructor(private dataService: DataService) { }

	updateHours(time, value) {
	}

	save() {
		if(this.validate()) {
			this.dataService.saveStoreHours(this.addressId, this.storeHours).subscribe(() => {
				this.onCancel.next(true);
			});
		}
	}
	cancel() {
		this.onCancel.next(true);
	}
	validate():boolean {
		this.errors = {};
		let isValid = true;
		if(!!this.storeHours.monOpen != !!this.storeHours.monClose) {
			this.errors.monOpen = !this.storeHours.monOpen;
			this.errors.monClose = !this.storeHours.monClose;
			isValid = false;
		}
		if(!!this.storeHours.tueOpen != !!this.storeHours.tueClose) {
			this.errors.tueOpen = !this.storeHours.tueOpen;
			this.errors.tueClose = !this.storeHours.tueClose;
			isValid = false;
		}
		if(!!this.storeHours.wedOpen != !!this.storeHours.wedClose) {
			this.errors.wedOpen = !this.storeHours.wedOpen;
			this.errors.wedClose = !this.storeHours.wedClose;
			isValid = false;
		}
		if(!!this.storeHours.thuOpen != !!this.storeHours.thuClose) {
			this.errors.thuOpen = !this.storeHours.thuOpen;
			this.errors.thuClose = !this.storeHours.thuClose;
			isValid = false;
		}
		if(!!this.storeHours.friOpen != !!this.storeHours.friClose) {
			this.errors.friOpen = !this.storeHours.friOpen;
			this.errors.friClose = !this.storeHours.friClose;
			isValid = false;
		}
		if(!!this.storeHours.satOpen != !!this.storeHours.satClose) {
			this.errors.satOpen = !this.storeHours.satOpen;
			this.errors.satClose = !this.storeHours.satClose;
			isValid = false;
		}
		if(!!this.storeHours.sunOpen != !!this.storeHours.sunClose) {
			this.errors.sunOpen = !this.storeHours.sunOpen;
			this.errors.sunClose = !this.storeHours.sunClose;
			isValid = false;
		}
		return isValid;

	}
}
